import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "task-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-content"
};
const _hoisted_4 = {
  class: "energy-wrap flex"
};
const _hoisted_5 = {
  class: "total-energy-wrap"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "total-energy-bg"
}, null, -1);
const _hoisted_7 = {
  class: "total-energy"
};
const _hoisted_8 = {
  class: "total-energy-value"
};
const _hoisted_9 = {
  class: "total-energy-label"
};
const _hoisted_10 = {
  class: "progress-wrap"
};
const _hoisted_11 = {
  class: "chest-wrap"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "chest-bg"
}, null, -1);
const _hoisted_13 = {
  class: "energy-line"
};
const _hoisted_14 = {
  class: "threshold-value"
};
const _hoisted_15 = {
  class: "task-wrap"
};
const _hoisted_16 = {
  class: "task-list"
};
const _hoisted_17 = {
  class: "task-center-wrap"
};
const _hoisted_18 = {
  class: "task-name"
};
const _hoisted_19 = {
  class: "task-rewards flex"
};
const _hoisted_20 = {
  class: "reward-item"
};
const _hoisted_21 = {
  class: "reward-amount"
};
const _hoisted_22 = {
  class: "task-right-wrap"
};
import { ref, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePageVisibility } from '@vant/use';
import { useHelpTool } from "@/hooks";
import { usePopupStore, useReddotStore } from '@/store';
import PopupHeader from '@/components/Common/PopupHeader';
import { queryTask, receiveTask, getTaskReward, getTaskBoxReward, successShared } from '@/api';
export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      t
    } = useI18n();
    const pageVisibility = usePageVisibility();
    const {
      doShare,
      doFollow,
      doEnterGame,
      openBrowser
    } = useHelpTool();
    const popupStore = usePopupStore();
    const redDotStore = useReddotStore();
    const chestList = ref([]);
    const taskList = ref([]);
    const currentEnergy = ref(0);
    watch(pageVisibility, (newValue, oldValue) => {
      if (newValue === 'visible') {
        fetchTask();
      }
    });
    onMounted(() => {
      fetchTask();

      //用于app调用js方法
      if (window.$bridge) {
        window.$bridge.registerHandler('sharedFaceBook', () => {
          successShared({
            type: 'facebook'
          }).then(res => {
            fetchTask();
          });
        });
      }
    });
    const fetchTask = () => {
      queryTask().then(res => {
        const {
          energy,
          tasks,
          boxs
        } = res.data || {};
        currentEnergy.value = energy;
        chestList.value = processChestList(boxs || []);
        // if (window.$bridge) {
        //   taskList.value = tasks || [];
        // } else {
        //   taskList.value = (tasks || []).filter(item => item.taskType.indexOf('share') < 0); // 隐藏分享任务
        // }
        taskList.value = tasks || [];
      });
    };
    const processChestList = list => {
      let prevChest = {
        threshold: 0
      };
      return list.map(item => {
        let remainEnergy = currentEnergy.value - prevChest.threshold;
        let itemEnergyTotal = item.threshold - prevChest.threshold;
        if (remainEnergy >= itemEnergyTotal) {
          item.completed = true;
          item.progressWidth = 100;
        } else if (remainEnergy <= 0) {
          item.progressWidth = 0;
          item.completed = false;
        } else if (remainEnergy < itemEnergyTotal) {
          item.progressWidth = remainEnergy / itemEnergyTotal * 100;
          item.completed = false;
        }
        prevChest = item;
        return item;
      });
    };
    const doReceive = activityId => {
      receiveTask({
        activityId
      }).then(res => {
        let task = res.data || {};
        taskList.value = taskList.value.map(item => {
          if (item.activityId === activityId) {
            item = task;
          }
          return item;
        });
        doGo(task);
      });
    };
    const doGetReward = item => {
      getTaskReward({
        activityId: item.activityId
      }).then(res => {
        fetchTask();
        popupStore.showRewards(item.rewards);
        // 处理外部红点数量展示
        redDotStore.getTaskReward();
      });
    };
    const doGetBoxReward = chest => {
      if (chest.status != 2) {
        return false;
      }
      getTaskBoxReward({
        activityId: chest.activityId
      }).then(res => {
        fetchTask();
        popupStore.showRewards(chest.rewards);
        // 处理外部红点数量展示
        redDotStore.getTaskReward();
      });
    };
    const doGo = item => {
      const {
        action,
        actionContent
      } = item || {};
      if (action === 'url') {
        openBrowser(actionContent);
      } else if (action === 'game') {
        doEnterGame(actionContent);
      } else if (action === 'share') {
        doShare({
          type: actionContent
        });
      } else if (action === 'follow') {
        doFollow({
          type: actionContent,
          isTask: true
        });
      } else if (action === 'page') {
        switch (actionContent) {
          case 'recharge':
            emit('onClose');
            popupStore.set('showDeposit');
            break;
          case 'follow':
            emit('onClose');
            popupStore.set('showSocialMedia');
            break;
          case 'bind':
            emit('onClose');
            popupStore.set('showProfile');
            break;
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        class: "full-page",
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(PopupHeader), {
          onOnClose: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(currentEnergy.value), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('task.totalActiveness')), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: _normalizeClass(`energy-pointer start ${currentEnergy.value > 0 ? 'active' : ''}`)
        }, null, 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chestList.value, (chest, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", {
            class: _normalizeClass(`energy-pointer ${chest !== null && chest !== void 0 && chest.completed ? 'active' : ''}`)
          }, null, 2), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
            class: "energy-line-active",
            style: _normalizeStyle(`width: ${chest.progressWidth}%`)
          }, null, 4)]), _createVNode(_component_van_image, {
            class: "chest-icon",
            style: _normalizeStyle(`width: ${90 * (0.25 + (index + 1) / chestList.value.length * 0.75)}px;`),
            src: chest.icon,
            onClick: $event => doGetBoxReward(chest)
          }, null, 8, ["style", "src", "onClick"]), _createElementVNode("div", _hoisted_14, _toDisplayString(chest.threshold), 1)]);
        }), 256))])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "task-item flex",
            key: item.activityId
          }, [_createVNode(_component_van_image, {
            class: "task-icon",
            src: item.icon
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rewards, reward => {
            return _openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_van_image, {
              class: "reward-icon",
              src: require(`@/assets/img/task/${reward.type}.png`)
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_21, "+" + _toDisplayString(reward.amount), 1)]);
          }), 256))])]), _createElementVNode("div", _hoisted_22, [item.status === 1 ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            class: "task-action-btn",
            onClick: $event => doReceive(item.activityId)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('common.goTo')), 1)]),
            _: 2
          }, 1032, ["onClick"])) : item.status === 2 && item.action ? (_openBlock(), _createBlock(_component_van_button, {
            key: 1,
            class: "task-action-btn",
            onClick: $event => doGo(item)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('common.goTo')), 1)]),
            _: 2
          }, 1032, ["onClick"])) : item.status === 3 ? (_openBlock(), _createBlock(_component_van_button, {
            key: 2,
            class: "task-reward-btn",
            onClick: $event => doGetReward(item)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('common.getReward')), 1)]),
            _: 2
          }, 1032, ["onClick"])) : item.status === 4 ? (_openBlock(), _createBlock(_component_van_image, {
            key: 3,
            class: "complete-icon",
            src: require('@/assets/img/task/complete.png')
          }, null, 8, ["src"])) : _createCommentVNode("", true)])]);
        }), 128))])])])])]),
        _: 1
      })]);
    };
  }
};